import styled from "styled-components";

export const StyledDetailsSection = styled.section`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    background: ${({ theme }) => theme.colorsV2.shyft.cream};
    height: 25%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .details-section {
    border-radius: 24px;
    background: ${({ theme }) => theme.colors.white};
    padding: 72px;
    .summary,
    .about,
    .skills,
    .responsibilities {
      margin: 0 0 32px;
      @media only screen and (max-width: 767px) {
        margin: 0 0 8px;
      }
    }
    .skill,
    .responsibility {
      padding-left: 24px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        background: ${({ theme }) => theme.colors.black};
        height: 4px;
        width: 4px;
        border-radius: 50%;
        top: 10px;
        left: 10px;
      }
    }
    .title {
      margin: 16px 0;
    }
    .skill-list,
    .responsibility-list {
      padding: 0 0 0 24px;
      @media only screen and (max-width: 767px) {
        padding: 0 0 0 16px;
      }
    }
    .misc {
      margin: 16px 0 0;
      p {
        margin: 0 0 8px;
        &:last-child {
          margin: 0;
        }
      }
    }
    @media only screen and (max-width: 767px) {
      padding: 24px 16px;
    }
  }
  .container {
    @media only screen and (max-width: 767px) {
      padding: 0 8px;
    }
  }
`;
